import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import "../Styling/UpdateViewExpenses.css";
import { updateExpense } from "../Api/ViewExpense";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import { useParams } from "react-router-dom";

const UpdateViewExpenses = () => {
  // const location = useLocation();
  // const expenseData = location.state?.expense;

  const { id } = useParams();

  const navigate = useNavigate();

  const { user } = useAuth();
  const [projects, setProjects] = useState([]);

  const [expenseOnValues, setExpenseOnValues] = useState([]);
  const [expenseOn, setExpenseOn] = useState("");

  const [formData, setFormData] = useState({
    project: "",
    expenses: {
      expenseId: "",
      expenseOn: "",
      expenseOnValue: "",
      paymentFromAccount: "",
      tripId: "",
      dateofExpense: "",
      projectId: "",
      expenseType: "",
      expenseType2: "",
      merchantName: "",
      amountSpent: "",
      currency: "",
      paymentMethod: "",
      receiptUpload: "",
      descriptionNotes: "",
      approvalStatus: "",
      paidStatus: false,
      createdAt: "",
    },
  });

  // useEffect(() => {
  //   if (expenseData?.expenses?.expenseOn) {
  //     setExpenseOn(expenseData.expenses.expenseOn);
  //   }
  // }, [expenseData]);

  // ✅ Pre-fill data
  // useEffect(() => {
  //   if (expenseData) {
  //     setFormData({
  //       project: expenseData.project || "",
  //       expenses: {
  //         expenseId: expenseData?.expenses?.expenseId || "",
  //         expenseOn: expenseData?.expenses?.expenseOn || "",
  //         expenseOnValue: expenseData?.expenses?.expenseOnValue || "",
  //         paymentFromAccount: expenseData?.expenses?.paymentFromAccount || "",
  //         tripId: expenseData?.expenses?.tripId || "",
  //         dateofExpense: expenseData?.expenses?.dateofExpense || "",
  //         projectId: expenseData?.expenses?.projectId || "",
  //         expenseType: expenseData?.expenses?.expenseType || "",
  //         expenseType2: expenseData?.expenses?.expenseType2 || "",
  //         merchantName: expenseData?.expenses?.merchantName || "",
  //         amountSpent: expenseData?.expenses?.amountSpent || "",
  //         currency: expenseData?.expenses?.currency || "",
  //         paymentMethod: expenseData?.expenses?.paymentMethod || "",
  //         receiptUpload: expenseData?.expenses?.receiptUpload || "",
  //         descriptionNotes: expenseData?.expenses?.descriptionNotes || "",
  //         approvalStatus: expenseData?.expenses?.approvalStatus || "",
  //         paidStatus: expenseData?.expenses?.paidStatus || false,
  //         createdAt: expenseData?.expenses?.createdAt || "",
  //       },
  //     });
  //   }
  // }, [expenseData]);

  useEffect(() => {
    const fetchExpense = async () => {
      try {
        const res = await axios.get(
          `${Base_URL}/ExpensesDetails/GetExpenseById?id=${id}`
        );
  
        const data = res.data?.expenses;
  
        const formatDate = (dateString) => {
  if (!dateString) return "";

  const [datePart] = dateString.split(" "); // "11/20/2025"
  const [month, day, year] = datePart.split("/");

  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};
  
        // ✅ FIX: correct mapping
        let expenseOnValue = "";
  
        if (data?.expenseOn === "Project") {
          expenseOnValue = data?.projectId;
        } else if (data?.expenseOn === "Cost Center") {
          expenseOnValue = data?.costCenterId;
        } else if (data?.expenseOn === "Employee/Resource") {
          expenseOnValue = data?.employeeId;
        } else if (data?.expenseOn === "Expense Group") {
          expenseOnValue = data?.tripId;
        }
  
        // ✅ SET EVERYTHING CORRECTLY
        setFormData({
          project: "",
          expenses: {
            expenseId: data?.expenseId || "",
            expenseOn: data?.expenseOn || "",
            expenseOnValue: expenseOnValue, // ✅ FIXED
  
            tripId: data?.tripId || "None",
            dateofExpense: formatDate(data?.dateofExpense),
  
            projectId: data?.projectId || "",
  
            expenseType: data?.expenseType || "",
            expenseType2: data?.expenseType2 || "",
  
            merchantName: data?.merchantName || "",
            amountSpent: data?.amountSpent || "",
  
            currency: data?.currency || "",
            paymentMethod: data?.paymentMethod || "",
  
            receiptUpload: data?.receiptUpload || "",
            descriptionNotes: data?.descriptionNotes || "",
  
            approvalStatus: data?.approvalStatus || "",
            paidStatus: data?.paidStatus || false,
            createdAt: data?.createdAt || "",
          },
        });
  
        // ✅ ONLY ONCE
        setExpenseOn(data?.expenseOn || "");
  
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch expense");
      }
    };
  
    if (id) fetchExpense();
  }, [id]);

  useEffect(() => {
    const fetchExpenseOnValues = async () => {
      try {
        if (expenseOn === "Project") {
          const res = await axios.get(
            `${Base_URL}/ProjectMaster/GetProjectsByOrg/${user.organisationId}`,
          );
          setExpenseOnValues(res.data || []);
        }

        if (expenseOn === "Cost Center") {
          const res = await axios.get(
            `${Base_URL}/DepartmentList/GetAllDepartments`,
          );
          setExpenseOnValues(res.data || []);
        }

        // if (expenseOn === "Employee/Resource") {
        //   const res = await axios.get(
        //     `${Base_URL}/Resource/GetResourcesByOrganisation/${user.organisationId}`,
        //   );
        //   setExpenseOnValues(res.data || []);
        // }

        if (expenseOn === "Expense Group") {
          const res = await axios.get(`${Base_URL}/ExpensesDetails/GetTripId`);
          setExpenseOnValues(res.data || []);
        }
      } catch (error) {
        console.error("Error fetching ExpenseOn values", error);
      }
    };

    if (expenseOn) {
      fetchExpenseOnValues();
    }
  }, [expenseOn, user?.organisationId]);

  useEffect(() => {
    const fetchProjects = async () => {
      if (!user?.organisationId) return;

      try {
        const res = await axios.get(
          `${Base_URL}/ProjectMaster/GetProjectsByOrg/${user.organisationId}`,
        );
        setProjects(res.data || []);
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };

    fetchProjects();
  }, [user?.organisationId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("SAVE CLICKED");

    try {
      const formDataToSend = new FormData();

formDataToSend.append("ExpenseId", formData.expenses.expenseId);
formDataToSend.append("TripId", formData.expenses.tripId || "None");

formDataToSend.append("ExpenseType", formData.expenses.expenseType);
formDataToSend.append("ExpenseType2", formData.expenses.expenseType2);

formDataToSend.append("MerchantName", formData.expenses.merchantName);
formDataToSend.append("AmountSpent", formData.expenses.amountSpent);

formDataToSend.append("Currency", formData.expenses.currency);
formDataToSend.append("PaymentMethod", formData.expenses.paymentMethod);

formDataToSend.append("DescriptionNotes", formData.expenses.descriptionNotes);

formDataToSend.append("ProjectId", formData.expenses.projectId);

formDataToSend.append("DateofExpense", formData.expenses.dateofExpense);

formDataToSend.append("ExpenseOn", formData.expenses.expenseOn);
formDataToSend.append("ExpenseOnValue", formData.expenses.expenseOnValue);

formDataToSend.append("PaymentFromAccount", formData.expenses.paymentFromAccount);

formDataToSend.append("PaidStatus", formData.expenses.paidStatus ?? false);

// console.log("Sending Data:");
// for (let pair of formDataToSend.entries()) {
//   console.log(pair[0], pair[1]);
// }

      await updateExpense(formDataToSend);

      toast.success("Expense Updated Successfully ✅");
    } catch (error) {
      console.error(error);
      toast.error("Error updating expense ❌");
    }
  };

  const handleExpenseOnChange = (e) => {
    const value = e.target.value;

    setExpenseOn(value);

    setFormData((prev) => ({
      ...prev,
      expenses: {
        ...prev.expenses,
        expenseOn: value,
        expenseOnValue: "",
      },
    }));
  };

  // ✅ Handle change for nested fields
  const handleChange = (e, field, isNested = false) => {
    if (isNested) {
      setFormData({
        ...formData,
        expenses: {
          ...formData.expenses,
          [field]: e.target.value,
        },
      });
    } else {
      setFormData({
        ...formData,
        [field]: e.target.value,
      });
    }
  };

  // if (!formData.expenses.expenseId) {
  //   return <p>Loading...</p>;
  // }

  return (
    <div className="main-content expand">
      <div className="update-expense-card">
        <h2 className="update-expense-title">Update Expense</h2>

        <form className="update-expense-grid" onSubmit={handleSubmit}>
          <div className="update-expense-group">
            <label>Expense ID</label>
            <input value={formData.expenses.expenseId} disabled />
          </div>

          <div className="update-expense-group">
            <label>Trip ID</label>
            <input value={formData.expenses.tripId} disabled />
          </div>

          <div className="update-expense-group">
            <label>Expense On</label>
            <select value={expenseOn} onChange={handleExpenseOnChange}>
              <option value="">Select</option>
              <option value="Project">Project</option>
              <option value="Cost Center">Cost Center</option>
              <option value="Employee/Resource">Employee/Resource</option>
              <option value="Expense Group">Expense Group</option>
            </select>
          </div>

          <div className="update-expense-group">
            <label>Expense On Value</label>

            <select
              value={formData.expenses.expenseOnValue || ""}
              onChange={(e) => handleChange(e, "expenseOnValue", true)}
            >
              <option value="">Select</option>

              {expenseOn === "Project" &&
                expenseOnValues.map((item) => (
                  <option key={item.projectId} value={item.projectId}>
                    {item.prTitle} - {item.projectId}
                  </option>
                ))}

              {expenseOn === "Cost Center" &&
                expenseOnValues.map((item) => (
                  <option key={item.deptId} value={item.deptId}>
                    {item.deptDescription} - {item.deptCode}
                  </option>
                ))}

              {expenseOn === "Employee/Resource" &&
                expenseOnValues.map((item) => (
                  <option key={item.resourceId} value={item.resourceId}>
                    {item.resourceName} - {item.resourceId}
                  </option>
                ))}

              {expenseOn === "Expense Group" &&
                expenseOnValues.map((item) => (
                  <option key={item.tripId} value={item.tripId}>
                    {item.tripName} - {item.tripId}
                  </option>
                ))}
            </select>
          </div>

          <div className="update-expense-group">
            <label>Date of Expense</label>
            <input
              type="date"
              value={formData.expenses.dateofExpense || ""}
              onChange={(e) => handleChange(e, "dateofExpense", true)}
            />
          </div>

          <div className="update-expense-group">
            <label>Project</label>
            <div className="update-expense-group">
              <select
                value={formData.expenses.projectId || ""}
                onChange={(e) => handleChange(e, "projectId", true)}
              >
                <option value="">Select Project</option>

                {projects.map((project) => (
                  <option key={project.projectId} value={project.projectId}>
                    {project.prTitle} - {project.projectId}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="update-expense-group">
            <label>Expense Type</label>
            <select
              value={formData.expenses.expenseType}
              onChange={(e) => handleChange(e, "expenseType", true)}
            >
              <option value="">Select Expense Type</option>
              <option value="Employee Travel">Employee Travel</option>
              <option value="Employee Client Visit">
                Employee Client Visit
              </option>
              <option value="Per DM">Per DM</option>
              <option value="Imprest">Imprest</option>
            </select>
          </div>

          <div className="update-expense-group">
            <label>Expense Type 2</label>
            <select
              value={formData.expenses.expenseType2}
              onChange={(e) => handleChange(e, "expenseType2", true)}
            >
              <option value="">Select Type</option>
              <option value="Water">Water</option>
              <option value="Tea">Tea</option>
              <option value="Petrol">Petrol</option>
              <option value="House">House keeping</option>
              <option value="House">Events</option>
            </select>
          </div>

          <div className="update-expense-group">
            <label>Merchant Name</label>
            <select
              value={formData.expenses.merchantName}
              onChange={(e) => handleChange(e, "merchantName", true)}
            >
              <option value="">Select Merchant Name</option>
              <option value="MAHESHWARI CAPS PVT. LTD.">
                MAHESHWARI CAPS PVT. LTD.
              </option>
              <option value="RAJ SOLUTIONS">RAJ SOLUTIONS</option>
              <option value="Krishna Trading Company">
                Krishna Trading Company
              </option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="update-expense-group">
            <label>Amount</label>
            <input
              value={formData.expenses.amountSpent}
              onChange={(e) => handleChange(e, "amountSpent", true)}
            />
          </div>

          <div className="update-expense-group">
            <label>Currency</label>
            <select
              value={formData.expenses.currency}
              onChange={(e) => handleChange(e, "currency", true)}
            >
              <option value="">Select Currency</option>
              <option value="INR">INR</option>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
            </select>
          </div>

          <div className="update-expense-group">
            <label>Payment Method</label>
            <select
              value={formData.expenses.paymentMethod}
              onChange={(e) => handleChange(e, "paymentMethod", true)}
            >
              <option value="">Select Payment Method</option>
              <option value="Cash">Cash</option>
              <option value="UPI">UPI</option>
            </select>
          </div>

          <div className="update-expense-group">
            <label>Payment From Account</label>
            <input
              type="text"
              value={formData.expenses.paymentFromAccount || ""}
              onChange={(e) => handleChange(e, "paymentFromAccount", true)}
            />
          </div>

          <div className="update-expense-group update-expense-full">
            <div className="update-expense-group">
              <label>Receipt Upload</label>
              <input
                type="file"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    expenses: {
                      ...formData.expenses,
                      receiptUpload: e.target.files[0],
                    },
                  })
                }
                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
              />
            </div>
          </div>

          <div className="update-expense-group update-expense-full">
            <label>Description</label>
            <textarea
              value={formData.expenses.descriptionNotes}
              onChange={(e) => handleChange(e, "descriptionNotes", true)}
            />
          </div>

          <div className="update-expense-actions">
            <button type="button" className="update-expense-reset">
              Reset
            </button>
            <button type="submit" className="update-expense-save">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateViewExpenses;